import React, { useEffect } from "react";
import Container from "@mui/material/Container";
import { useTheme } from "@emotion/react";
import Grid from "@mui/material/Grid";
import {
  Backdrop,
  Card,
  CardContent,
  CircularProgress,
  FormHelperText,
  Link,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import InputComponent from "../components/forms/InputComponent";
import SubmitButton from "../components/forms/SubmitButton";
import Form from "../components/forms/Form";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../actions/userActions";
import { toast } from "react-toastify";

const validationSchema = Yup.object().shape({
  name: Yup.string().required().label("Name").min(4),
  email: Yup.string().required().label("Email").email(),
  password: Yup.string().required().label("Password").min(4),
});
const SignUp = () => {
  const { palette } = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userRegister = useSelector((state) => state.userRegister);
  const { loading, success, error, userInfo } = userRegister;

  if (userInfo) {
    navigate("/dashboard", { replace: true });
    toast(`Logged in as ${userInfo.name}`);
  }

  useEffect(() => {
    if (success) {
      navigate("/dashboard", { replace: true });
    }
  }, [userInfo, navigate, success, dispatch]);

  const handleSubmit = async ({ name, email, password }) => {
    dispatch(register(name, email, password));
  };

  return (
    <div
      style={{
        backgroundColor: palette.primary.main,
        height: "100vh",
        width: "100vw",
        display: "flex",
      }}
    >
      <Container maxWidth="sm">
        {loading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}

        <Grid
          container
          spacing={2}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Grid item xs={12} md={12} m={"auto"}>
            <Card variant="outlined">
              <CardContent>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h5"
                    component="h2"
                    style={{
                      color: palette.primary.main,
                      fontWeight: "bold",
                      fontSize: "30px",
                    }}
                  >
                    Sign up for an account
                  </Typography>
                  <Form
                    onSubmit={handleSubmit}
                    initialValues={{ name: "", email: "", password: "" }}
                    validationSchema={validationSchema}
                  >
                    <InputComponent label="name" type="text" />
                    <InputComponent label="email" type="email" />
                    <InputComponent label="password" type="password" />
                    <SubmitButton title={`Register`} />
                  </Form>
                  <Typography variant="body1">
                    Already have an account?
                    <Link href="/" color="primary">
                      Sign In
                    </Link>
                  </Typography>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default SignUp;
